import { Injectable } from "@angular/core";

export enum LetteringScopeEnum {
    GLOBAL = 'GLOBAL',
    BY_ACCOUNT = 'BY_ACCOUNT'
}

export type LetteringScopeType = {
    label: string;
    value: keyof typeof LetteringScopeEnum;
};

@Injectable()
export class LetteringScopeService {

    private readonly letteringScopeOptionsList: LetteringScopeType[] = [
        {
            label: "Lettrage global",
            value: "GLOBAL"
        },
        {
            label: "Lettrage par compte",
            value: "BY_ACCOUNT"
        },
    ];

    public getAll(): LetteringScopeType[] {
        return [...this.letteringScopeOptionsList]; // to avoid side effects
    }
}